import React from 'react';
import PropTypes from 'prop-types';
import ChangeAccordionItem from "../components/ChangeAccordionItem";
import {useMemoizedProposedValue} from "../helpers";
import KeySection from "../components/KeySection";
import {useCurrentValue} from "../components/useCurrentValue";
import {displayOnlyPropertiesFor, hiddenPropertiesFor} from "./commonFunctions";

const BillingAddressChange = ({billingAddressChanged, billingAddressIndex}) => {
    const key = "changedBillingAddresses[" + billingAddressIndex + "]"
    const npi = useMemoizedProposedValue(billingAddressChanged.keys, "NPI");
    const tin = useMemoizedProposedValue(billingAddressChanged.keys, "TIN");
    const lineOfService = useMemoizedProposedValue(billingAddressChanged.keys, "Line of Service");
    const effectiveDate = useMemoizedProposedValue(billingAddressChanged.keys, "Effective Date");
    const hiddenProperties = hiddenPropertiesFor();
    const displayOnlyProperties = displayOnlyPropertiesFor();

    return (
            <ChangeAccordionItem properties={billingAddressChanged.properties} 
                                 controlId={key} 
                                 effectiveDate={effectiveDate}
                                 header={"NPI " + npi + ", TIN " + tin + ", Line of Service " + lineOfService}
                                 index={billingAddressIndex}
                                 hiddenPropertyNames={hiddenProperties}
                                 displayOnlyPropertyNames={displayOnlyProperties}
            >
                <KeySection keys={billingAddressChanged.keys}
                            tooltip={"The keys are used to identify a unique remittance address in a file and match it to what's already in Trellis"}
                >
                </KeySection>
            </ChangeAccordionItem>
    )
}
BillingAddressChange.propTypes = {
    billingAddressChanged: PropTypes.object.isRequired,
    billingAddressIndex: PropTypes.number.isRequired
}
export default BillingAddressChange